export default __webpack_public_path__ + "static/media/main-logo.d2fbfc94.svg";